import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../store';

interface AdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that allows admin and superadmin users.
 * Regular users are redirected to the home page.
 */
export const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const user = useAppSelector(state => state.auth.user);

  if (user?.role !== 'superadmin' && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
